// For the web we need to provide the config directly
// Native builds get the config from google-services.json GoogleService-Info.plist
import {getFirebaseConfig} from '../app/AppConfig';
import firebase from 'firebase/compat/app';

const initializeApp = (): void => {
  firebase.initializeApp(getFirebaseConfig());
};

export default initializeApp;
